var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseGrayCircleSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00001 14.6668C4.31801 14.6668 1.33334 11.6822 1.33334 8.00016C1.33334 4.31816 4.31801 1.3335 8.00001 1.3335C11.682 1.3335 14.6667 4.31816 14.6667 8.00016C14.6667 11.6822 11.682 14.6668 8.00001 14.6668ZM8.00001 7.0575L6.11468 5.1715L5.17134 6.11483L7.05734 8.00016L5.17134 9.8855L6.11468 10.8288L8.00001 8.94283L9.88534 10.8288L10.8287 9.8855L8.94268 8.00016L10.8287 6.11483L9.88534 5.1715L8.00001 7.0575Z",
    fill: "#9CA2A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrayCircleSmall);
export default __webpack_public_path__ + "static/media/close-gray-circle-small.518ddb3d865cdc509598f68ddd43d055.svg";
export { ForwardRef as ReactComponent };